import _typeof from "@babel/runtime/helpers/esm/typeof";
import { UNDEFINED } from './const';
export var isUndefined = function isUndefined(value) {
  return value === UNDEFINED;
};
export var isDefined = function isDefined(value) {
  return value !== UNDEFINED;
};
export var isNull = function isNull(value) {
  return value === null;
};
export var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
export var isNumber = function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
};
export var isString = function isString(value) {
  return typeof value === 'string';
};
export var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
export var isArray = function isArray(value) {
  return Array.isArray(value);
};
export var isObject = function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
};
export var isSymbol = function isSymbol(value) {
  return _typeof(value) === 'symbol';
};
export var isRegExp = function isRegExp(value) {
  return Object.prototype.toString.call(value) === '[object RegExp]';
};
export var isStream = function isStream(value) {
  return isObject(value) && isFunction(value.pipe);
};
export var isError = function isError(value) {
  return value instanceof Error;
};
//# sourceMappingURL=is.js.map